import React, { Component } from "react";
import Radio from "./radio";
import { Col, Row } from "react-bootstrap";

export default class Attendees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attendees: props.data,
    };

    let params = new URLSearchParams(window.location.search);
    let attendeesNumber = params.get('attendees_number');
    if (attendeesNumber) {
      const index = this.state.attendees.findIndex((a) => parseInt(a.value) === parseInt(attendeesNumber));
      if (index !== -1) {
        this.state.attendees[index].checked = true
        this.props.onChange("attendees_number", parseInt(attendeesNumber));
      }
    }
  }

  handleChange = (checked, index) => {
    this.setState(
      ({ attendees }) => ({
        attendees: attendees.map((a, idx) =>
          idx === index ? { ...a, checked: true } : { ...a, checked: false }
        )
      })
    );
    this.props.onChange("attendees_number", parseInt(checked.target.value));
  };

  render() {
    return (
      <div>
        <Row>
          <Col>
            <h4 className="ui centered question-header text-center">
              How many attendees do you expect?
            </h4>
          </Col>
        </Row>
        <Row md="4" sm="2" xs="1">
          {this.state.attendees.map((attendee, index) => (
            <Radio
              key={`attendee-${index}`}
              name={`attendee-${index}`}
              onChange={(value) => this.handleChange(value, index)}
              attendee={attendee}
              label={attendee.label}
            />
          ))}
        </Row>
      </div>
    );
  }
}
